import { addTheme } from "./addTheme.js";
import { activeThemeManagers } from "./hooks/useTheme.js";
function updateTheme({
  name,
  theme
}) {
  const next = addTheme({ name, theme, insertCSS: true, update: true });
  if (process.env.TAMAGUI_TARGET === "native") {
    activeThemeManagers.forEach((manager) => {
      if (manager.state.name === name) {
        manager.updateState({
          name,
          forceTheme: next.theme
        });
      }
    });
  }
  return next;
}
export {
  updateTheme
};
//# sourceMappingURL=updateTheme.js.map
